<!-- @format -->

<template>
  <div
    class="prm-list"
    v-loading="pageloading"
  >
    <main-head>
      <template v-slot:pageName>
        {{ $t("page.list") }}
      </template>
      <template v-slot:headBtn>
        <!-- <el-button type="primary" size="medium">
          {{ $t("page.exportProduct") }}
        </el-button> -->
        <!-- <el-button
          type="primary"
          v-if="isChannelRole === true && !btnSet.includes('btn_prm_create')"
          size="medium"
          @click="toAdd"
        >
          {{ $t("page.addProject") }}
        </el-button> -->
        <a
          class="clause-a"
          type="primary"
          href="javascript:void(0)"
          v-if="start"
          @click="showClause"
          >{{ $t("page.prmList.showClauseSBG") }}</a
        >
        <a
          class="clause-a"
          type="primary"
          href="javascript:void(0)"
          v-if="starts"
          @click="showClauses"
          >{{ $t("page.prmList.showClauseEBG") }}</a
        >
      </template>
    </main-head>
    <main-content>
      <template v-slot:contentArea>
        <div class="form">
          <el-form
            ref="form"
            :model="form"
            label-width="185px"
          >
            <el-row :gutter="60">
              <el-col :span="5">
                <el-form-item
                  :label="$t('page.prmList.registration')"
                  label-width="120px"
                  class="registration"
                />
                <el-input
                  v-model="form.registrationNo"
                  :placeholder="$t('message.registrationNo')"
                  maxlength="256"
                  @blur="getList(form.registrationNo, 'registrationNo')"
                />
              </el-col>
              <el-col :span="5">
                <el-form-item
                  :label="$t('page.prmList.projectName')"
                  label-width="100px"
                  class="positionAdjustment"
                />
                <el-input
                  v-model="form.projectName"
                  :placeholder="$t('message.needProjectName')"
                  maxlength="256"
                  @blur="getList(form.projectName, 'projectName')"
                />
              </el-col>
              <el-col
                :span="5"
                v-if="!isChannelRole"
              >
                <el-form-item :label="$t('page.prmList.partnerName')" />
                <el-input
                  v-model="form.partnerName"
                  :placeholder="$t('message.needPartnerName')"
                  maxlength="256"
                  @blur="getList(form.partnerName, 'partnerName')"
                />
              </el-col>
              <el-col
                :span="5"
                v-if="!isChannelRole"
              >
                <el-form-item :label="$t('page.prmList.country')" />
                <el-select
                  v-model="form.nation"
                  clearable
                  filterable
                  :placeholder="$t('message.select')"
                >
                  <el-option
                    v-for="item in allCountries"
                    :value="item.areaCode"
                    :key="item.areaCode"
                    :label="item.areaName"
                  />
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-form-item
                  :label="$t('page.prmList.ruijieSaleName')"
                  class="positionAdjustment"
                />
                <el-input
                  v-model="form.ruijieSaleName"
                  :placeholder="$t('message.needRuijieSaleName1')"
                  maxlength="256"
                  @blur="getList(form.ruijieSaleName, 'ruijieSaleName')"
                />
              </el-col>
              <el-col :span="5">
                <el-form-item
                  :label="$t('page.prmList.approvalState')"
                  class="positionAdjustment"
                />
                <el-select
                  v-model="form.approvalstate"
                  clearable
                  filterable
                  :placeholder="$t('message.select')"
                >
                  <el-option
                    v-for="item in stepList"
                    :key="item.stepId"
                    :label="item.stepName"
                    :value="item.stepId"
                  />
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-form-item
                  :label="$t('page.prmList.projectStep')"
                  class="positionAdjustment"
                />
                <el-select
                  v-model="form.languageKey"
                  clearable
                  filterable
                  :placeholder="$t('message.select')"
                >
                  <el-option
                    v-for="item in projectStep"
                    :key="item.stepId"
                    :label="item.languageValue"
                    :value="item.languageKey"
                  />
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-form-item
                  :label="$t('page.prmList.createTime')"
                  class="positionAdjustment"
                />
                <el-date-picker
                  v-model="createTime"
                  type="daterange"
                  range-separator=""
                  value-format="yyyy-MM-dd"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  cell-class-name="search-date-picker"
                  style="width: 100%;"
                />
              </el-col>
              <el-col :span="5">
                <el-form-item
                  :label="$t('page.prmList.expireTime')"
                  class="positionAdjustment"
                />
                <el-date-picker
                  v-model="expireTime"
                  type="daterange"
                  range-separator=""
                  value-format="yyyy-MM-dd"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  cell-class-name="search-date-picker"
                  style="width: 100%;"
                />
              </el-col>
              <el-col
                :span="!isChannelRole ? 7 : 7"
                style="margin-top: 45px"
              >
                <el-button
                  v-if="!btnSet.includes('btn_prm_search')"
                  type="primary"
                  class="submit"
                  @click="clickSearchBtn"
                  size="medium"
                  plain
                  >{{ $t("common.search") }}</el-button
                >
                <el-button
                  class="cancle"
                  size="medium"
                  v-if="!btnSet.includes('btn_prm_search')"
                  plain
                  @click="registe"
                  >{{ $t("common.reset") }}</el-button
                >
                <el-button
                  class="submit"
                  v-if="!btnSet.includes('btn_prm_export')"
                  size="medium"
                  @click="exportToExcel"
                  >{{ $t("common.export") }}</el-button
                >
                <el-button
                  class="submit"
                  size="medium"
                  @click="handleExportTemplate"
                  >{{ $t("page.exportProduct") }}</el-button
                >
              </el-col>
            </el-row>
            <!-- <el-row :gutter="60">
              <el-col :span="18" style="text-align:right; margin-top:45px;">
                <el-button type="primary" class="submit" @click="clickSearchBtn" size="medium" plain>{{ $t("common.search") }}</el-button>
                <el-button class="cancle" size="medium" plain @click="registe">{{ $t("common.reset") }}</el-button>
                <el-button class="submit" size="medium" @click="exportToExcel">{{ $t("common.export") }}</el-button>
              </el-col>
            </el-row> -->
          </el-form>
        </div>
        <div class="table">
          <el-table
            :data="tabledata"
            border
            style="width: 100%; font-size: 14px"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              prop="registrationNo"
              align="center"
              :label="$t('page.prmList.registration')"
              :render-header="fullHeader"
              show-overflow-tooltip
            />
            <el-table-column
              prop="projectName"
              align="center"
              :label="$t('page.prmList.projectName')"
              :render-header="fullHeader"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <a
                  class="pointer"
                  @click="goviewpage(scope.row)"
                >
                  {{ scope.row.projectName }}
                </a>
              </template>
            </el-table-column>
            <el-table-column
              prop="partnerName"
              align="center"
              :label="$t('page.prmList.partnerName')"
              :render-header="fullHeader"
              show-overflow-tooltip
              v-if="!isChannelRole"
            />
            <el-table-column
              prop="areaName"
              align="center"
              :render-header="fullHeader"
              v-if="!isChannelRole"
              :label="$t('page.prmList.country')"
              width="120px"
            />
            <el-table-column
              prop="ruijieSaleName"
              align="center"
              :label="$t('page.prmList.ruijieSaleName')"
              :render-header="fullHeader"
              show-overflow-tooltip
            />
            <el-table-column
              prop="createUserName"
              align="center"
              :label="$t('page.prmList.applicant')"
              :render-header="fullHeader"
              show-overflow-tooltip
              v-if="!isChannelRole"
            />
            <el-table-column
              prop="createTime"
              align="center"
              :label="$t('page.prmList.submitTime')"
              :render-header="fullHeader"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ parseTime(scope.row.createTime, "{y}-{m}-{d}") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="stepName"
              align="center"
              :label="$t('page.prmList.approvalState')"
              :render-header="fullHeader"
              show-overflow-tooltip
            />
            <el-table-column
              prop="projectStatusValue"
              align="center"
              :label="$t('page.prmList.prmState')"
              :render-header="fullHeader"
              show-overflow-tooltip
            />
            <el-table-column
              prop="projectPhaseValue"
              align="center"
              :label="$t('page.prmNew.projectPhase')"
              :render-header="fullHeader"
              show-overflow-tooltip
            />
            <el-table-column
              prop="expectedOrderDate"
              align="center"
              :label="$t('page.prmNew.expctedOrderDate')"
              :render-header="fullHeader"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ parseTime(scope.row.expectedOrderDate, "{y}-{m}-{d}") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              align="center"
              :label="$t('page.prmNew.lastUpdata')"
              :render-header="fullHeader"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ parseTime(scope.row.updateTime, "{y}-{m}-{d}") }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="date"
              align="center"
              fixed="right"
              :label="$t('message.operation')"
              width="220px"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="goeditpage(scope.row)"
                  v-if="scope.row.canEdit != null && scope.row.canEdit"
                >
                  {{ $t("common.edit") }}
                </el-button>
                <el-button
                  type="text"
                  size="medium"
                  @click="showDialog(scope.row)"
                  v-if="scope.row.canDiscard != null && scope.row.canDiscard"
                >
                  {{ $t("common.discard") }}
                </el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <el-dialog
            :title="$t('message.hints')"
            :visible.sync="dialogVisible"
            width="30%"
          >
            <span>{{ $t("page.prmList.discardReason") }}</span>
            <br /><br />
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="dreason"
              maxlength="500"
              @blur="getListS(dreason, 'dreason')"
            />
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button @click="dialogVisible = false">{{
                $t("message.cancel")
              }}</el-button>
              <el-button
                type="primary"
                @click="discard()"
                >{{ $t("message.comfirm") }}</el-button
              >
            </span>
          </el-dialog>
          <div
            class="paging"
            style="text-align: right; margin-top: 20px"
          >
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page.currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="page.pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            />
          </div>
        </div>
        <div class="clear" />
        <el-dialog
          :title="$t('message.clause')"
          :visible.sync="agreeClauseVisible"
          width="50%"
          center
        >
          <span style="height: 500px; overflow: auto; display: block">
            <b>1. Program Objective</b><br />
            The Ruijie Project Protection Program (RPPP) objective is to protect
            the projects of registered partners, certified partners, gold
            partners, silver partners, Sub-D and VAD to guarantee the interests
            of the partners.<br />
            <b>2. Project Protection Description</b><br />
            2.1 A new project shall refer to a project that has a potential
            order of Ruijie products of more than 6,000 USD.<br />
            2.2 For Ruijie registered partners, after the approval of project
            registration, a 30-day protection period shall be provided. The
            project shall not be protected after the expiry date.<br />
            Please proceed with the project during the protection period and
            update the progress to the partner project registration system in
            time. After update, the project shall undergo the re-approval
            process.<br />
            2.2.1 If the updated content is valid, the approval shall be
            notified by email and the 30-day validity period shall be
            recalculated from the date of approval.<br />
            2.2.2 If the updated content is invalid, the rejection shall be
            notified by email, and the validity period shall remain
            unchanged.<br />
            2.3 For Ruijie certified partners, silver partners, gold partners,
            Sub-D and VAD, after the approval of project registration, a 60-day
            protection period shall be provided. The project shall not be
            protected after the expiry date.<br />
            Please proceed with the project during the protection period and
            update the progress to the partner project registration system in
            time. After update, the project shall undergo the re-approval
            process.<br />
            2.3.1 If the updated content is valid, the approval shall be
            notified by email and the 60-day validity period shall be
            recalculated from the date of approval.<br />
            2.3.1 If the updated content is invalid, the rejection shall be
            notified by email, and the validity period shall remain
            unchanged.<br />
            <b>3 Program Procedures</b><br />
            3.1 Log in to the partner system to fill in the project information,
            channel partner information and end user information, and submit the
            project registration.<br />
            3.2 The project shall be approved by the Ruijie sales representative
            of the country, and the approval process shall be completed by the
            Ruijie sales representative within 3 working days.<br />
            3.3 If supplementary information is required for project
            registration, the Ruijie sales representative shall reject the
            project and request additional information.<br />
            3.4 The project registration date refers to the date of the
            approval. If the project information is updated, sales
            representative’s re-approval is required. After reapproval, the
            project registration date shall be updated.<br />
            <img
              src="../../assets/process.png"
              alt
              width="50%"
            /><br />
            <b>4. Disclaimer</b><br />
            In order to better ensure the interests of the partners, Ruijie
            Networks has provided the project protection terms. Nevertheless, it
            is difficult to achieve complete protection for every project.
            Ruijie Networks shall do its utmost to ensure the highest extent of
            project protection, and the understanding and support from our
            partners would be greatly appreciated.
          </span>
          <br /><br /><br />
          <span v-if="agreeClause === false">
            <el-checkbox v-model="readAndAgree">{{
              $t("message.readAndAgree")
            }}</el-checkbox>
          </span>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              v-if="agreeClause === false"
              :disabled="readAndAgree !== true"
              type="primary"
              @click="clickAgreeClause"
              >{{ $t("message.agree") }}</el-button
            >
            <el-button @click="agreeClauseVisible = false">{{
              $t("message.close")
            }}</el-button>
          </span>
        </el-dialog>
        <el-dialog
          :title="$t('message.clause')"
          :visible.sync="agreeClauseVisibleEBG"
          width="50%"
          center
        >
          <span style="height: 500px; overflow: auto; display: block">
            <b style="font-size: 20px">Ruijie Deal Registration Program </b
            ><br /><br />
            Ruijie’s Deal Registration Program is a program open to all Ruijie
            channel partners’ sales personnel(include but no limited to BDM,
            Account Manager, Sales Manager/Rep, Inside sales rep, Product
            Manager & etc) to proactively submit sales funnel and work together
            to close it with Ruijie. <br /><br />
            This program aims to foster collaboration between Ruijie and its
            partners, while also providing protection and recognition for
            partners' efforts in driving sales growth.<br /><br />
            <b>Objectives:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Encourage channel partners (RAD &
            RAP) to proactively identify and pursue new sales opportunities for
            Ruijie's products & solutions.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Protect partners' investment of time
            and resources in cultivating sales opportunities.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enable Ruijie & channel partner to
            manage sales pipeline effectively & systematically, optimize
            resource allocation, and drive revenue growth.<br /><br />
            <b>Registration Process:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Channel partners (RAD or RAP) submit
            detailed information about prospective deals, including end customer
            details, opportunity size, timeline, and all other relevant
            information through Ruijie partner portal
            <a
              style="color: red"
              href="https://partners.ruijienetworks.com/home"
              >(https://partners.ruijienetworks.com/home)</a
            >.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Deal Registration submitted will be
            review and approve by Ruijie in 5-7 working days based on predefined
            eligibility criteria (stated in detail as below).<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Channel partner will receive a
            notification after deal registration been approved or rejected.<br /><br />
            <b>Scope of Registration:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The deal registration program applies
            to new sales opportunities that have not been previously registered
            or engaged with Ruijie EBG (Enterprise Business Group).<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Channel Partner’s Deal Registration
            approval are first come first serve basis follow by date and time of
            deal registration submission captured by Ruijie’s deal registration
            online system.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;For Public Tender or Open RFP, no
            deal registration will be allowed. Channel Partner may engage our
            sales team for tender cooperation.<br /><br />
            <b>Exclusivity and Protection:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Approved Deal Registration grants the
            registering partner exclusivity and protection for the business
            opportunity within the designated sales territory follow channel
            partner’s and approver’s in-charge country.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ruijie agrees not to engage with or
            register the same opportunity with any other partner during the
            registration term, except under exceptional circumstances which will
            be communicate with channel partner by case basis.<br /><br />
            <b>Deal Tracking and Management:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ruijie maintained Deal Registration
            Online System (https://partners.ruijienetworks.com/dealreg) to track
            and manage registered opportunities throughout the sales cycle. Only
            deal registration that submitted and approved through this system
            will be recognized as valid deal registration.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Only related sales person(s) have
            visibility into registered deals, enabling them to prioritize
            resources, provide support, and monitor progress toward closure.
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Channel Partner are also required to
            actively provide deal update every 2 months to keep the deal
            registration active and valid. <br /><br />
            <b>Renewal and Extension:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Each new deal registration submitted
            will be valid for 6 months from the deal registration submission
            date.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Each Deal Registration will be
            subject to renewal or extension upon request by channel partner
            through system before the DR expired. Extension will be valid for
            maximum of 6 months period.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Channel Partner will need to submit a
            new deal registration for approval after above cycle end. (note:
            cycle refers to first 6 months + 6 months extension)<br /><br />
            <b>Compliance and Auditing:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ruijie will conduct due diligence for
            each deal registration submission to identify all information
            submitted are comply with all the terms and policy of deal
            registration.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ruijie also reserve rights to conduct
            audits or reviews of registered opportunities to ensure compliance
            with program requirements and detect any potential fraud or
            abuse.<br /><br />
            <b>Modification and Termination:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The company reserves the right to
            modify or terminate the deal registration program at any time, with
            or without prior notice, at its sole discretion.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Any changes to the program will be
            communicated to channel partners in a timely manner, and all
            registered opportunities existing at the time of modification or
            termination will be subject to the revised terms and conditions.<br /><br />
            <b>Dispute Resolution:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In the event of disputes or
            disagreements regarding deal registration, channel partners may
            submit their concerns to the company's designated point of contact
            for resolution.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ruijie will make reasonable efforts
            to address and resolve disputes in a fair and timely manner, with
            the ultimate goal of preserving the integrity of the registration
            program and maintaining positive partner relationships.<br /><br />
            <b style="font-size: 20px">Terms & Policies:</b><br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.Once partner submits a Deal
            Registration, channel and sales team will perform initial review to
            ensure that opportunity has not been Deal Registered previously by
            another partner or is not the opportunity that we already working
            with any other party.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.Deal Registration team will check to
            make sure any Deal Registration criteria, T&C, product or solution
            scope are met.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.Partners will receive email
            notification as to Deal Registration status upon approval or
            rejection.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.Only authorized partners
            (distributor or tier-2 reseller) with good standing can submit Deal
            Registrations.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.Only one Deal Registration can be
            accepted for an opportunity.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.New Deal Registrations are valid for
            6 months (or 180 days) and eligible for an extension of (6 months)
            upon Ruijie’s approval.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.Partner must actively manage the
            deal (include putting effort in presales stages such as: POC, site
            visit, attend to project meeting, etc) and update the deal with
            progress in deal registration online portal at least once every 2
            months to remain the validity of the deal registration. <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.Partner must play an active role in
            or capable to pursue deals; for example, having access to a relevant
            contract if a public deal, having available credit to close the
            deal. If not, Registration may be revoked.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.If the opportunity arises as a
            result of a Public Tender/Open RFP, no Deal Registration will be
            allowed. Channel partners are advisable to work closely with sales
            team in such circumstances.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.All requests are subject to review
            by Ruijie and it is at their sole discretion to grant or deny any
            Registration.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11.Ruijie reserve the right to exclude
            products from this Deal Registration program at their sole and
            exclusive discretion.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;12.Ruijie reserves the rights to
            modify the Partner Deal Registration Program at any time and without
            prior notice.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13.Standard discounts may be given on
            orders where the partner is only providing fulfillment and not
            contributing to the sales process even have an approved Deal
            Registration.<br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14.Partner takes full responsibility
            for obtaining consent or justification for the use of any
            information, including any personal data related to your prospect or
            customer, provided to Ruijie for the purpose of obtaining a Deal
            Registration. Ruijie will protect all such data in the same manner
            as all sales data is protected in Ruijie’s order management and
            Ruijie’s CRM systems of record.<br /><br />
          </span>
          <br /><br /><br />
          <span v-if="agreeClauseEBG === false">
            <el-checkbox v-model="readAndAgreeEBG">{{
              $t("message.readAndAgree")
            }}</el-checkbox>
          </span>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              v-if="agreeClauseEBG === false"
              :disabled="readAndAgreeEBG !== true"
              type="primary"
              @click="clickAgreeClauseEBG"
              >{{ $t("message.agree") }}</el-button
            >
            <el-button @click="agreeClauseVisibleEBG = false">{{
              $t("message.close")
            }}</el-button>
          </span>
        </el-dialog>

        <el-dialog title="System Update: Deal Registration is Now Live"
          :visible.sync="transferVisible"
          width="570px"
          center>
          <p style="font-size: 16px">The transition is complete. This legacy Project Registration System is now in <span style="font-weight: bold">read-only mode.</span></p>
          <ul style="font-size: 16px; margin-top: 18px; line-height: 150%; padding: 18px; background-color: rgb(255,251,227); border-radius: 4px; color: rgb(130,105,80); padding-left: 36px">
            <li><span style="font-weight: bold">Data Frozen:</span> All records here are frozen as of <span style="font-weight: bold">March 12</span> and will no longer update.</li>
            <li style="margin-top: 12px"><span style="font-weight: bold">Next Steps:</span> To create or modify projects, please proceed to the new <span style="font-weight: bold">Deal Registration</span> system.</li>
            <li style="margin-top: 12px"><span style="font-weight: bold">Final Shutdown:</span> This system will be permanently shut down by <span style="font-weight: bold">May 1</span>, after which it will no longer be accessible for viewing.</li>
          </ul>
          <p style="margin-top: 24px; line-height: 150%">Thank you for your support during this transition.</p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="transferVisible = false">Got it</el-button>
            <el-button type="primary" @click="goToDealRegistration">Go to Deal Registration</el-button>
          </span>
        </el-dialog>
      </template>
    </main-content>
  </div>
</template>

<script>
import API from "../../API";
import { formate } from "../../libs/mixin";
import mainHead from "../component/mainHead";
import mainContent from "../component/mainContent";
import { merge, dateDiff, downloadBlobFile } from "../../libs/util";
import store from "../../store";
import dayjs from "dayjs";

export default {
  name: "PrmList",
  mixins: [formate],
  data() {
    return {
      starts: false,
      start: false,
      tabledata: [],
      pageloading: false,
      page: {
        currentPage: 1,
        pagesize: 20,
        total: 0,
      },
      createTime: [],
      expireTime: [],
      form: {
        registrationNo: "",
        projectName: "",
        partnerName: "",
        ruijieSaleName: "",
        nation: "",
        approvalstate: "",
        languageKey: "",
        userId: "",
        createTimeStart: "", // 创建时间开始
        createTimeEnd: "", // 创建时间结束
        expireTimeStart: "", // 过期时间开始
        expireTimeEnd: "", // 过期时间结束
      },
      stepList: [],
      projectStep: [],
      allCountries: [],
      selectRow: "",
      dialogVisible: false, // 是否废弃窗口
      isChannelRole: false,
      dreason: "",
      agreeClause: false,
      agreeClauseEBG: false,
      agreeClauseVisible: false,
      agreeClauseVisibleEBG: false,
      readAndAgree: false,
      readAndAgreeEBG: false,
      btnSet: [],
      transferVisible: true,
    };
  },
  components: {
    mainHead,
    mainContent,
  },
  methods: {
    getList(value, values) {
      // console.log(A);
      this.form[values] = value.trim();
    },
    getListS(value, values) {
      this[values] = value.trim();
    },
    tableRowClassName({ row, rowIndex }) {
      let dateDifference = dateDiff(new Date(), new Date(row.stagnationTime));
      if (dateDifference >= 0 && dateDifference < 10) {
        return "remind-row";
      } else {
        return "";
      }
    },
    toAdd() {
      // console.log(!(this.start && this.starts));
      // eslint-disable-next-line eqeqeq
      if (!(this.start || this.starts)) {
        this.$message.error(this.$t("message.setDepartment"));
      } else if (!this.start) {
        this.$router.push({
          name: "PrmNewEBG",
        });
      } else {
        this.$router.push({ name: "prmNew" });
      }
    },
    showClause() {
      this.agreeClauseVisible = true;
    },
    showClauses() {
      this.agreeClauseVisibleEBG = true;
    },
    clickAgreeClause() {
      API.readAndAgreeClause()
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.agreeClause = true;
            this.agreeClauseVisible = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickAgreeClauseEBG() {
      API.readAndAgreeClause()
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.agreeClauseEBG = true;
            this.agreeClauseVisibleEBG = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    showDialog(row) {
      this.selectRow = row;
      this.dialogVisible = true;
    },
    init() {
      API.getDepartments()
        .then((res) => {
          let json = res.data;
          // eslint-disable-next-line no-undef, eqeqeq
          if (json.data.indexOf("ebgDept") != -1) {
            this.starts = true;
            this.start = false;
          }
          // eslint-disable-next-line eqeqeq, no-undef
          if (json.data.indexOf("sbgDept") != -1) {
            this.start = true;
            this.starts = false;
          }
          // eslint-disable-next-line eqeqeq
          if (json.data == []) {
            this.start = false;
            this.starts = false;
          }
          // console.log(this.start, this.starts, showAgree, 1111);
          if (this.start) {
            this.agreeClauseVisible = showAgree;
            this.agreeClause = !showAgree;
          } else {
            this.agreeClauseVisibleEBG = showAgree;
            this.agreeClauseEBG = !showAgree;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      API.getProjectStep(this.$i18n.locale)
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.projectStep = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      API.getAllCountries(this.$i18n.locale)
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.allCountries = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      API.getAllSteps(this.$i18n.locale)
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.stepList = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      let showAgree;
      API.getCurUser()
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            showAgree = !json.data.agreeClause;
            this.form.userId = json.data.userId;
            this.search();
            this.getCurUserRole();
            // console.log(showAgree);
          }
        })
        .catch((e) => {
          console.log(e);
        });
      // console.log(showAgree);
    },
    clickSearchBtn() {
      this.page.currentPage = 1;
      this.search();
    },
    search() {
      this.pageloading = true;
      let params = {
        projectPhaseKey: this.form.languageKey,
        registrationNo: this.form.registrationNo.trim(),
        pageNum: this.page.currentPage,
        pageSize: this.page.pagesize,
        projectName: this.form.projectName.trim(),
        partnerName: this.form.partnerName,
        ruijieSaleName: this.form.ruijieSaleName.trim(),
        areaCode: this.form.nation,
        stepId: this.form.approvalstate,
        language: this.$i18n.locale,
        createTimeStart: this.form.createTimeStart ? dayjs(this.form.createTimeStart).startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 创建时间开始
        createTimeEnd: this.form.createTimeEnd ? dayjs(this.form.createTimeEnd).startOf("day")
          .add(86399, "second")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 创建时间结束
        expireTimeStart: this.form.expireTimeStart ? dayjs(this.form.expireTimeStart).startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 过期时间开始
        expireTimeEnd: this.form.expireTimeEnd ? dayjs(this.form.expireTimeEnd).startOf("day")
          .add(86399, "second")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 过期时间结束
      };
      API.getList(params)
        .then((res) => {
          this.pageloading = false;
          let json = res.data;
          if (json.status === "200") {
            this.tabledata = json.data.list;
            this.page.total = json.data.total;
          }
        })
        .catch((ex) => {
          this.pageloading = false;
        });
    },
    exportToExcel() {
      let params = encodeURIComponent(
        JSON.stringify({
          registrationNo: this.form.registrationNo,
          projectName: this.form.projectName,
          partnerName: this.form.partnerName,
          ruijieSaleName: this.form.ruijieSaleName,
          areaCode: this.form.nation,
          stepId: this.form.approvalstate,
          language: this.$i18n.locale,
          createTimeStart: this.form.createTimeStart ? dayjs(this.form.createTimeStart).startOf("day")
            .format("YYYY-MM-DD HH:mm:ss")
            .toString() : void 0, // 创建时间开始
          createTimeEnd: this.form.createTimeEnd ? dayjs(this.form.createTimeEnd).startOf("day")
            .add(86399, "second")
            .format("YYYY-MM-DD HH:mm:ss")
            .toString() : void 0, // 创建时间结束
          expireTimeStart: this.form.expireTimeStart ? dayjs(this.form.expireTimeStart).startOf("day")
            .format("YYYY-MM-DD HH:mm:ss")
            .toString() : void 0, // 过期时间开始
          expireTimeEnd: this.form.expireTimeEnd ? dayjs(this.form.expireTimeEnd).startOf("day")
            .add(86399, "second")
            .format("YYYY-MM-DD HH:mm:ss")
            .toString() : void 0, // 过期时间结束
        })
      );
      API.productFile(params)
        .then((res) => {
          // eslint-disable-next-line no-unused-expressions
          // console.log(res);
          // 取后端给前端返的请求头中的文件名称
          // const temp = res.headers['content-disposition'].split(';')[1].split('filename=')[1];
          // const fileName = decodeURIComponent(temp);
          let stamp = new Date().getTime() + 8 * 60 * 60 * 1000;
          let beijingTime = new Date(stamp)
            .toISOString()
            .replace(/T/, " ")
            .replace(/\..+/, "")
            .substring(0, 19);
          // 获取切换用户后的登录信息 .log(beijingTime);
          downloadBlobFile({
            content: res.data,
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            fileName: "List_of_items-" + beijingTime + ".xls",
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    handleExportTemplate() {
      let params = {
        projectPhaseKey: this.form.languageKey,
        registrationNo: this.form.registrationNo.trim(),
        projectName: this.form.projectName.trim(),
        partnerName: this.form.partnerName,
        ruijieSaleName: this.form.ruijieSaleName.trim(),
        areaCode: this.form.nation,
        stepId: this.form.approvalstate,
        language: this.$i18n.locale,
        createTimeStart: this.form.createTimeStart ? dayjs(this.form.createTimeStart).startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 创建时间开始
        createTimeEnd: this.form.createTimeEnd ? dayjs(this.form.createTimeEnd).startOf("day")
          .add(86399, "second")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 创建时间结束
        expireTimeStart: this.form.expireTimeStart ? dayjs(this.form.expireTimeStart).startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 过期时间开始
        expireTimeEnd: this.form.expireTimeEnd ? dayjs(this.form.expireTimeEnd).startOf("day")
          .add(86399, "second")
          .format("YYYY-MM-DD HH:mm:ss")
          .toString() : void 0, // 过期时间结束
      };
      API.productExport(params)
        .then((res) => {
          let stamp = new Date().getTime() + 8 * 60 * 60 * 1000;
          let beijingTime = new Date(stamp)
            .toISOString()
            .replace(/T/, " ")
            .replace(/\..+/, "")
            .substring(0, 19);
          downloadBlobFile({
            content: res.data,
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            fileName: "List_templat-" + beijingTime + ".xls",
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleSizeChange(val) {
      this.page.pagesize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search();
    },
    fullHeader(h, { column }) {
      if (column.label) {
        return h(
          "el-tooltip",
          {
            attrs: {
              class: "item",
              effect: "dark",
              content: column.label,
              placement: "bottom",
            },
          },
          [h("span", [column.label])]
        );
      }
    },
    goviewpage(row) {
      let query = merge(this.$route.query, {
        objectId: row.id,
        start: this.start,
        starts: this.starts,
      });
      // eslint-disable-next-line eqeqeq
      if (!(this.start || this.starts)) {
        this.$message.error(this.$t("message.setDepartment"));
      } else {
        this.$router.push({
          name: "prmDtl",
          query: query,
        });
      }
    },
    goeditpage(row) {
      let query = merge(this.$route.query, {
        objectId: row.id,
        isControl: true,
      });
      // console.log(query);
      // eslint-disable-next-line eqeqeq
      if (!(this.start || this.starts)) {
        this.$message.error(this.$t("message.setDepartment"));
      } else if (this.starts) {
        this.$router.push({
          name: "prmEditEBG",
          query: query,
        });
      } else {
        this.$router.push({
          name: "prmEdit",
          query: query,
        });
      }
    },
    discard() {
      if (!this.dreason || this.dreason.trim() === "") {
        this.$notify.error({
          title: this.$t("message.needDiscardReason"),
        });
        return false;
      }
      API.discard(this.selectRow.id, this.dreason)
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.$notify({
              title: this.$t("discardSuccess"),
              type: "success",
            });
            this.search(this.filter);
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.dialogVisible = false;
    },
    registe() {
      this.form = {
        registrationNo: "",
        projectName: "",
        partnerName: "",
        ruijieSaleName: "",
        nation: "",
        approvalstate: "",
        languageKey: "",
        userId: "",
        createTimeStart: "", // 创建时间开始
        createTimeEnd: "", // 创建时间结束
        expireTimeStart: "", // 过期时间开始
        expireTimeEnd: "", // 过期时间结束
      };
      this.createTime = [];
      this.expireTime = [];
      this.page = {
        currentPage: 1,
        pagesize: 20,
        total: 0,
      };
      this.search();
    },
    goToDealRegistration() {
      window.open('https://partner.ruijie.com/project-registry-management/project-list?params=241');
    },
    getCurUserRole() {
      API.getCurUserRole()
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.isChannelRole = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.btnSet = store.state.UserBtnPermissionsData || [];
    this.init();
  },
  watch: {
    createTime(newVal) {
      if (Array.isArray(newVal) && newVal.length === 2) {
        this.form.createTimeStart = newVal[0];
        this.form.createTimeEnd = newVal[1];
      } else {
        this.form.createTimeStart = "";
        this.form.createTimeEnd = "";
      }
    },
    expireTime(newVal) {
      if (Array.isArray(newVal) && newVal.length === 2) {
        this.form.expireTimeStart = newVal[0];
        this.form.expireTimeEnd = newVal[1];
      } else {
        this.form.expireTimeStart = "";
        this.form.expireTimeEnd = "";
      }
    }
  }
};
</script>

<style lang="scss">
.prm-list {
  .form {
    .el-form-item__label {
      text-align: left;
    }
  }

  .table {
    margin-top: 20px;
  }

  .paging {
    margin-top: 20px;
    float: right;
  }

  .clear {
    clear: both;
  }

  .el-select {
    width: 100%;
  }

  .clause-a {
    margin-left: 20px;
    margin-right: 20px;
    color: #8b8b8b;
    text-decoration: underline;
  }

  .el-table .remind-row {
    background: #f08080;
  }
}
.positionAdjustment {
  position: relative;
  top: 10px;
}
.pointer {
  color: red;
}
.pointer:hover {
  cursor: pointer;
  color: blue;
}
.search-date-picker {
  width: 100% !important;
}
</style>
